import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a81dceea"
import script from "./vuetifyTabs.js?vue&type=script&lang=js&external"
export * from "./vuetifyTabs.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=a81dceea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports